// src/app/auth/layout.tsx
'use client';

import Image from 'next/image';
import cn from 'classnames';
import Logo from '@/shared/assets/images/logo.png';
import AuthPageHeader from './ui/AuthPageHeader';
import styles from './ui/styles.module.scss';

export default function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className={cn('relative min-h-dvh grid grid-rows-[auto,1fr]', styles.wrapper)}>
      {/* Fixed full-viewport background layer (theme-aware via CSS) */}
      <div aria-hidden className='auth-bg-layer fixed inset-0 -z-10' />

      {/* Header */}
      <AuthPageHeader />

      {/* ===== MOBILE (<=768px): branding ARRIBA, form ABAJO ===== */}
      <div className='block md:!hidden flex flex-col items-center gap-5 px-1 py-10'>
        <section
          className={cn(
            'self-center', // center as flex item
            'flex flex-col items-center text-center gap-3 rounded-2xl',
            'px-6 py-4',
            'bg-[var(--Gray-100)] border border-[var(--Gray-200)]',
            'w-auto shrink-0',
            styles.left
          )}
          style={{ width: 'clamp(280px, calc(100vw - 32px), 360px)' }}
        >
          <div className='mb-3'>
            <div className={cn(styles.logo)} /* tamaño por SCSS; ajustado por media query */>
              <Image src={Logo} alt='logo' priority className='w-[52%] h-[52%] object-contain' sizes='(max-width: 768px) 150px' />
            </div>
          </div>

          <div>
            <h1 className='m-0 text-xl font-semibold tracking-tight text-white max-[360px]:text-[17px]'>Wisevizer</h1>
            <p className='m-0 mt-1 text-[15px] max-[360px]:text-[14px] text-[rgb(163,163,163)]'>Admin panel</p>
          </div>
        </section>
        <section className='flex items-center justify-center mb-6 w-full'>
          <div className='w-full max-w-[360px] mx-auto'>{children}</div>
        </section>
      </div>

      {/* ===== DESKTOP (>=768px): layout original ===== */}
      <main className={cn('!hidden md:!grid md:grid-cols-2 gap-5 px-4 md:px-1 py-1', styles.content)}>
        <section
          className={cn('flex flex-col items-center justify-center text-center gap-4', 'rounded-2xl p-8 md:p-10', 'bg-[var(--Gray-100)] border border-[var(--Gray-200)]', styles.left)}
          data-admin
        >
          <div className={cn('mb-4', styles.logo)}>
            <Image src={Logo} alt='logo' priority />
          </div>

          <div>
            <h1 className={cn('text-2xl font-semibold tracking-tight text-white', styles.title)}>Wisevizer</h1>
            <p className={cn('text-sm text-[rgb(163,163,163)]', styles.text)}>Admin panel</p>
          </div>
        </section>

        {/* DER: Form */}
        <section className={cn('flex items-center justify-center', 'rounded-2xl p-0 md:p-0', styles.container)}>
          <div className='w-full max-w-md'>{children}</div>
        </section>
      </main>
    </div>
  );
}
